import { render, staticRenderFns } from "./ChosenWords.vue?vue&type=template&id=574422c7&"
import script from "./ChosenWords.vue?vue&type=script&lang=js&"
export * from "./ChosenWords.vue?vue&type=script&lang=js&"
import style0 from "./ChosenWords.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports